module.exports = __webpack_public_path__ + "static/media/transactions_16_white.489757c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/transactions_16_white.svg
// module id = 1408
// module chunks = 0